<script lang="ts">
  /* The departure window, over the real route and the real current model. */
  import DeparturePanelUI from '@gennetay/chart-ui/panels/DeparturePanel';
  import { autoroute } from '@gennetay/chart-core/lib/autoroute.svelte';
  import { viewTime } from '@gennetay/chart-core/lib/viewtime.svelte';
  import { departures } from '../departures.svelte';
  import { resolveRoute } from '../route.svelte';
</script>

<DeparturePanelUI
  options={departures.options}
  done={departures.done}
  total={departures.total}
  unavailable={departures.reason()}
  onreplan={() => void departures.plan()}
  onpick={(t) => {
    /* Setting a departure also parks the time cursor, because planning a
       passage against a tide you cannot see is the failure the cursor exists to
       prevent: the current field, the stream arrows and the tide stations
       behind this all move to the water the plan is being made in. */
    autoroute.departT = t;
    viewTime.scrub(t);
    void resolveRoute();
  }}
/>
